import {Component, Inject} from '@angular/core';
import {StoreSelectorsService} from '../../services';
import {Compbaser} from "../compbaser";
import {TranslocoService} from "@ngneat/transloco";
import { HttpClient } from "@angular/common/http";
import {Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NewNodeDialog} from "../category-tree/add-node/add-node.component";


@Component({
    selector: 'app-dialog-version',
    templateUrl: './dialog-version.component.html',
    styleUrls: ['./dialog-version.component.scss']
})
export class DialogVersionComponent extends Compbaser {

    version;

    constructor(
        public dialogRef: MatDialogRef<NewNodeDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private storeSelectorsService: StoreSelectorsService,
        private translocoService: TranslocoService,
        private _http: HttpClient, private router: Router) {
        super();
        this.version = data;
    }

    reload() {
        this.dialogRef.close(true);
    }

}
